import React, { useState, useEffect } from 'react';
import './../Styles/ProfileDialog.css'; 
import axios from 'axios';
import { useToast } from './ToastContext';
const apiUrl = process.env.REACT_APP_API_URL;


const ProfileDialog = ({ employeeInfo, onClose, onUpdate }) => {
    const [formData, setFormData] = useState({ ...employeeInfo });
    const [managerName, setManagerName] = useState('');
    const showToast = useToast();

    useEffect(() => {
        setFormData({ ...employeeInfo });
    }, [employeeInfo]);

    useEffect(() => {
        const fetchManagerName = async () => {
            const employeeNumber = formData.employee_number || formData.employee_id;
            console.log('Fetching manager of employee:', employeeNumber);

            if (!employeeNumber) {
                console.error('No employee number available');
                return;
            }

            try {
                const response = await axios.get(`${apiUrl}/api/manager-emp/${employeeNumber}`);
                console.log('Fetched manager data:', response.data);
                setManagerName(response.data.full_name || 'Manager Not Assigned');
            } catch (error) {
                console.error('Error fetching manager name:', error);
                setManagerName('Error fetching manager');
            }
        };

        fetchManagerName();
    }, [formData.employee_number, formData.employee_id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const hasChanges = Object.keys(formData).some(
            key => formData[key] !== (employeeInfo ? employeeInfo[key] : undefined)
        );

        if (!hasChanges) {
            showToast('No changes were made.', 'info');
            return;
        }

        try {
            const response = await axios.post(`${apiUrl}/api/update-user`, formData);

            if (response.status === 200) {
                console.log('User details updated successfully');
                showToast('Profile updated successfully!', 'success');
                if (onUpdate) {
                    onUpdate(formData);
                }
                onClose();
            } else {
                console.error('Failed to update user details');
                showToast('Failed to update profile.', 'error');
            }
        } catch (error) {
            console.error('Error updating user details:', error);
            showToast(error.response?.data?.message || 'Error updating profile.', 'error');
        }
    };


    return (
        <div className="profile-dialog-overlay">
            <div className="profile-dialog-content">
            <div className="profile-dialog-header">
                    <h2>My Profile</h2>
                    {/* <img src={formData.profileImage || 'default-profile.png'} alt="Profile" /> */}
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="profile-dialog-grid">
                        <div className="profile-dialog-row">
                            <label htmlFor="fullName">Full Name</label>
                            <input
                                id="fullName"
                                type="text"
                                name="full_name"
                                value={formData.full_name || ''}
                                onChange={handleChange}
                                placeholder="Enter full name"
                            />
                        </div>
                        <div className="profile-dialog-row">
                            <label htmlFor="jobTitle">Job Title</label>
                            <input
                                id="jobTitle"
                                type="text"
                                name="job_title"
                                value={formData.job_title || ''}
                                onChange={handleChange}
                                placeholder="Enter job title"
                            />
                        </div>
                        <div className="profile-dialog-row">
                            <label htmlFor="employeeNumber">Employee ID</label>
                            <input
                                id="employeeNumber"
                                type="text"
                                name="employee_number"
                                value={formData.employee_number || ''}
                                onChange={handleChange}
                                placeholder="Enter employee ID"
                                disabled
                            />
                        </div>
                        <div className="profile-dialog-row">
                            <label htmlFor="email">Email</label>
                            <input
                                id="email"
                                type="email"
                                name="username"
                                value={formData.username || ''}
                                onChange={handleChange}
                                placeholder="Enter email"
                                disabled
                            />
                        </div>
                        <div className="profile-dialog-row">
                            <label htmlFor="department">Department</label>
                            <input
                                id="department"
                                type="text"
                                name="department"
                                value={formData.department || ''}
                                onChange={handleChange}
                                placeholder="Enter department"
                            />
                        </div>
                        <div className="profile-dialog-row">
                            <label htmlFor="project">Project</label>
                            <input
                                id="project"
                                type="text"
                                name="project"
                                value={formData.project_name || ''}
                                onChange={handleChange}
                                placeholder="Enter project"
	                        disabled
                            />
                        </div>
                        <div className="profile-dialog-row">
                            <label htmlFor="location">Location</label>
                            <input
                                id="location"
                                type="text"
                                name="location"
                                value={formData.location || ''}
                                onChange={handleChange}
                                placeholder="Enter location"
                            />
                        </div>
                        <div className="profile-dialog-row">
                            <label htmlFor="reportingTo">Reporting to</label>
                            <input
                                id="reportingTo"
                                type="text"
                                value={managerName}
                                disabled
                            />
                        </div>
                    </div>
                    <div className="form-actions">
                        <button type="submit">Update</button>
                        <button type="button" className="cancel" onClick={onClose}>Cancel</button>
                    </div>
                </form>
                
            </div>
        </div>
    );
};

export default ProfileDialog;
